import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

function NavBar() {
  const [navActive, setNavActive] = useState(false);

  const toggleNav = () => setNavActive((v) => !v);
  const closeMenu = () => setNavActive(false);

  // Close mobile menu when switching to desktop sizes
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) closeMenu();
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const linkBase =
    "navbar--content text-lg py-2 lg:py-0 opacity-80 hover:opacity-100 transition";
  const linkActive = "underline underline-offset-8 opacity-100";

  return (
    <nav className="sticky top-0 w-full bg-white/90 backdrop-blur border-b border-black/5 z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
        {/* Logo / Brand */}
        <NavLink to="/" onClick={closeMenu} className="flex-shrink-0">
          <img
            className="w-16 h-auto"
            src={`${process.env.PUBLIC_URL}/img/Group.svg`}
            alt="Sarah's Logo"
          />
        </NavLink>

        {/* Hamburger (mobile) */}
        <button
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={navActive}
          onClick={toggleNav}
          className="lg:hidden inline-flex flex-col gap-1.5"
        >
          <span className="block h-0.5 w-7 bg-black/80"></span>
          <span className="block h-0.5 w-7 bg-black/80"></span>
          <span className="block h-0.5 w-7 bg-black/80"></span>
        </button>

        {/* Links (desktop + mobile dropdown) */}
        <div
          className={`${
            navActive ? "block" : "hidden"
          } lg:block absolute lg:static top-full left-0 w-full lg:w-auto bg-white lg:bg-transparent border-b lg:border-0 border-black/5`}
        >
          <ul className="flex flex-col lg:flex-row items-center gap-4 lg:gap-8 p-6 lg:p-0">
            {/* <li>
              <NavLink
                to="/"
                end
                onClick={closeMenu}
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? linkActive : ""}`
                }
              >
                Home
              </NavLink>
            </li> */}

            <li>
              <NavLink
                to="/about"
                onClick={closeMenu}
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? linkActive : ""}`
                }
              >
                About
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/dev"
                onClick={closeMenu}
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? linkActive : ""}`
                }
              >
                Projects
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/research"
                onClick={closeMenu}
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? linkActive : ""}`
                }
              >
                Publications
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/art"
                onClick={closeMenu}
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? linkActive : ""}`
                }
              >
                Visual Arts
              </NavLink>
            </li>

            <li>
              <a
                href={`${process.env.PUBLIC_URL}/Sarah-Jacob-Resume.pdf`}
                target="_blank"
                rel="noreferrer"
                className={linkBase}
                onClick={closeMenu}
              >
                CV
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
